import type { HotelLocation } from '@shared/types/hotel-content';

const CITY_TYPE = 'City';
const COUNTRY_TYPE = 'Nation';
const ADDRESS_REGION_TYPE = 'FirstLevelNationAdministrativeDivision';

export const buildHotelLocation = (location: HotelLocation) => {
  const { address, parents, postcode } = location;
  const city = parents?.find(({ type }) => type === CITY_TYPE);
  const country = parents?.find(({ type }) => type === COUNTRY_TYPE);
  const addressRegion = parents?.find(
    ({ type }) => type === ADDRESS_REGION_TYPE,
  )?.name;

  return {
    country: country?.name,
    countryId: country?.id,
    city: city?.name,
    cityId: city?.id,
    addressRegion,
    address,
    postcode,
  };
};
